import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Column } from 'devextreme/ui/data_grid';
import { Subscription } from 'rxjs';
import { ChangeMode, DataService, ObjectKeys } from '../../../services/data.service';
import { GridComponent, ToastType } from '@wissenswerft/ww-library';
import { PersistMode } from '@wissenswerft/core/data';
import { AppService } from '../../../services/app.service';
import { MeasureDefinition } from '@xmt-models';
@Component({
  selector: 'measure-definition',
  templateUrl: './measure-definition.component.html',
  styleUrls: ['./measure-definition.component.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MeasureDefinitionComponent implements OnInit, OnDestroy {
  @ViewChild('measureDefGrid') measureDefGrid: GridComponent;
  public measureDefList: MeasureDefinition[] = [];
  public showLoader: boolean;
  public title: string;
  private subscriptions: Subscription[] = [];
  public columnsHeader: Column[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    public dataService: DataService,
    public appService: AppService) { }

  ngOnInit(): void {
    this.showLoader = true;
    this.dataService.readObjects<MeasureDefinition[]>(ObjectKeys.MEASUREDEFINITIONLIBRARY).subscribe(measureDefinitions => {
      this.columnsHeader.push({
        dataField: 'Designation',
        caption: this.dataService.res('Cmt-Designation'),
        dataType: 'string'
      });
      if (Array.isArray(measureDefinitions) && measureDefinitions.length > 0) {
        this.measureDefList = measureDefinitions;
      } else {
        this.measureDefList = [];
      }
      this.cdr.markForCheck();
    }, error => {
      this.appService.callNotification({ message: error, type: ToastType.ERROR });
      console.error(error);
    }, () => {
      this.showLoader = false;
    })
  }

  public addRow() {
    this.measureDefGrid.addRow();
  }

  public persistMeasureDef = (event): void => {
    if (event.changes[0].type === ChangeMode.Insert) {
      this.subscriptions.push(this.dataService.persistObject<MeasureDefinition>(ObjectKeys.MEASUREDEFINITIONLIBRARY, PersistMode.Insert, event.changes[0].key.Designation).subscribe(measureDefinition => {
        if (!this.measureDefList[this.measureDefList.length - 1]?.Id) {
          this.measureDefList[this.measureDefList.length - 1].Id = measureDefinition.Id;
        }
      }, error => {
        console.error(error);
        this.appService.callNotification({ message: error, type: ToastType.ERROR });
      }, () => {
        this.appService.callNotification({ message: this.dataService.res("Cmt-Notification-Success"), type: ToastType.SUCCESS });
      }));
    } else if (event.changes[0].type === ChangeMode.Remove) {
      this.subscriptions.push(this.dataService.deleteObject(ObjectKeys.MEASUREDEFINITIONLIBRARY, event.changes[0].key.Id).subscribe(measureDefinitions => {
        this.dataService.updateGridData(measureDefinitions);
      }, error => {
        console.error(error);
        this.appService.callNotification({ message: error, type: ToastType.ERROR })
      }, () => {
        this.appService.callNotification({ message: this.dataService.res("Cmt-Notification-Success"), type: ToastType.SUCCESS });
      }));
    } else {
      this.subscriptions.push(this.dataService.persistObject(ObjectKeys.MEASUREDEFINITIONLIBRARY, PersistMode.Update, event.changes[0].key.Designation, event.changes[0].key.Id).subscribe(measureDefinitions => {
        this.dataService.updateGridData(measureDefinitions);
      }, error => {
        console.error(error);
        this.appService.callNotification({ message: error, type: ToastType.ERROR })
      }, () => {
        this.appService.callNotification({ message: this.dataService.res("Cmt-Notification-Success"), type: ToastType.SUCCESS })
      }));
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.map(subscription => { subscription.unsubscribe(); });
  }

}

